import { MouseEvent } from "react";
import { useHistory } from "react-router";
import Slider2Image from "../../assets/img/content/section2.png";
import Section3Image from "../../assets/img/content/section3.png";
import Section4Image from "../../assets/img/content/section4.png";

const HowItWorksComponent = () => {
    const history = useHistory();

    const signIn = (event: MouseEvent) => {
        event.preventDefault();
        history.push("/login");
    };

    return (
        <div>
            <section className="bg-light md">
                <div className="container-body">
                    <div className="row">
                        <div className="col-lg-5 mb-4 mb-lg-0">
                            <img src={Slider2Image} alt="..." className="employer-pic"></img>
                        </div>
                        <div className="col-lg-7">
                            <div className="ps-lg-1-9">
                                <h2 className="section-title">Employer</h2>
                                <p className="text-info-categories">
                                    IamInterviewed empowers employers to accelerate technical hiring by managing candidate assessments end-to-end, allowing your teams to focus on delivering client projects without unnecessary interruptions.
                                </p>
                                <h6 className="title-how-it-works">How it works</h6>
                                <ul className="list-unstyled section2-links">
                                    <li><i className="far fa-check-circle section2-links-link"></i> Register</li>
                                    <li><i className="far fa-check-circle section2-links-link"></i> Share profile and job description</li>
                                    <li><i className="far fa-check-circle section2-links-link"></i> IamInterviewed schedules and completes interview</li>
                                    <li><i className="far fa-check-circle section2-links-link"></i> Shortlist Profile</li>
                                </ul>
                                <div className="">
                                    <p className="text-info-categories">Accelerate your hiring journey—take the next step with IamInterviewed now.</p>
                                    <a className="butn primary" onClick={(e) => { signIn(e); }}><span>Sign in</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="bg-light md scetion3">
                <div className="container-body">
                    <div className="row">
                        <div className="col-lg-7">
                            <h2 className="section-title-white">Candidates</h2>
                            <p className="text-info-categories-white">
                                IamInterviewed helps candidates showcase their technical skills through unbiased interviews, connecting you with leading employers and maximising your chances for the right opportunity.
                            </p>
                            <p className="title-how-it-works-white">How it works</p>
                            <div>
                                <ul className="list-unstyled scetion3-links">
                                    <li><i className="far fa-check-circle scetion3-links-link"></i> Register</li>
                                    <li><i className="far fa-check-circle scetion3-links-link"></i> Schedule Interview</li>
                                    <li><i className="far fa-check-circle scetion3-links-link"></i> Get interviewed, RATED</li>
                                    <li><i className="far fa-check-circle scetion3-links-link"></i> Get visible</li>
                                </ul>
                            </div>
                            <div className="">
                                <p className="text-info-categories-white">Advance your career opportunities—take the next step with IamInterviewed now.</p>
                                <a className="butn white" onClick={(e) => { signIn(e); }}><span>Sign in</span></a>
                            </div>
                        </div>
                        <div className="col-lg-5 mb-4 mb-lg-0">
                            <img src={Section3Image} alt="..." className="employer-pic2"></img>
                        </div>
                    </div>
                </div>
            </section>
            <section className="bg-light md">
                <div className="container-body">
                    <div className="row">
                        <div className="col-lg-5 mb-4 mb-lg-0">
                            <img src={Section4Image} alt="..." className="employer-pic"></img>
                        </div>
                        <div className="col-lg-7">
                            <div className="ps-lg-1-9">
                                <h2 className="section-title">Interviewer</h2>
                                <p className="text-info-categories">
                                    IamInterviewed provides interviewers with a platform to leverage their expertise, conduct meaningful assessments, and play a key role in building top-performing teams across industries.
                                </p>
                                <p className="title-how-it-works">How it works</p>
                                <div>
                                    <ul className="list-unstyled section4-links">
                                        <li><i className="far fa-check-circle section4-links-link"></i> Register</li>
                                        <li><i className="far fa-check-circle section4-links-link"></i> Get Approval from IamInterviewed</li>
                                        <li><i className="far fa-check-circle section4-links-link"></i> Start Interview</li>
                                    </ul>
                                </div>
                                <div className="">
                                    <p className="text-info-categories">Contribute your expertise—join IamInterviewed and make an impact today.</p>
                                    <a className="butn primary" onClick={(e) => { signIn(e); }}><span>Sign in</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};
export default HowItWorksComponent;